exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* TEXTFIELD */\n\n/* LIST */\n\n/* ==========  Layout  ========== */\n\n/* BUTTON */\n\n/* ANIMATION */\n\n/* Small control size */\n\n.date-range-container {\n  display: inline-block;\n}\n\n.date-range-container .preposition-label {\n  color: #9E9E9E;\n  padding: 0 3px;\n}\n\n", ""]);

// exports
